import React from 'react'
import PropTypes from 'prop-types'
import StatusBadge from 'components/atoms/status-badge'
import { PHOTO_CURATION_STATUS } from 'domains/merchant-product/constants'

const propTypes = {
  photoCurationStatus: PropTypes.string.isRequired
}

/**
 * To give nice look on Merchant Product `photo_curation_status`.
 * It maps `curation_status` to certain style and pass to `StatusBadge`.
 * @param {string} photoCurationStatus
 */
const MerchantInboundItemPhotoCurationStatusBadge = ({ photoCurationStatus }) => {

  const colorMap = {
    [PHOTO_CURATION_STATUS.PENDING]             : 'warning',
    [PHOTO_CURATION_STATUS.ACCEPTED]            : 'success',
    [PHOTO_CURATION_STATUS.REQUIRE_PHOTOGRAPHY] : 'danger',
    [PHOTO_CURATION_STATUS.REQUIRE_PHOTO_EDIT]  : 'primary'
  }

  const color = colorMap[photoCurationStatus] || 'default'

  return <StatusBadge color={ color } label={ photoCurationStatus } />
}

MerchantInboundItemPhotoCurationStatusBadge.propTypes = propTypes

export default MerchantInboundItemPhotoCurationStatusBadge
